import src from "IMAGE";
export default { src, width: 240, height: 180, blurDataURL: "data:image/webp;base64,UklGRlgAAABXRUJQVlA4TEwAAAAvB0ABAM1VICICHgiwCQAAAIALAAFwBAAEAAAIAAgAAAAAAAAAAAAAAAAAByAAQACgQhKgqwYJACAi8tJvtIKaJJutOLMvyw4coqcH", blurWidth: 8, blurHeight: 6 }
